// @flow
import { createReducer } from 'actions';
import { LOAD_LOGS } from 'actions/logs';
import { LOGOUT } from 'actions/auth';
import type { Log, LoadLogsAction } from 'actions/logs';

type State = Array<Log>;

const initialState: State = [];

export default createReducer(initialState, {
  [LOAD_LOGS]: (state: State, action: LoadLogsAction) => {
    if (action.meta.done && !action.meta.error && action.payload) {
      return [...action.payload];
    }
    return state;
  },

  [LOGOUT]: () => {
    return [];
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/logs.js